import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'

@Component({
  selector: 'form-search-os-proposal-client',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-search-os-proposal-client.component.html',
  styleUrl: './form-search-os-proposal-client.component.scss',
})
export class FormSearchOsProposalClientComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private proposalStatusService: ProposalStatusService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')
  datepickerEmission = viewChild<MatDatepicker<any>>('dateEmission')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  listStatus: any[] = []
  //   [
  //   { id: 0, description: 'Todos' },
  //   { id: 1, description: 'Aprovada' },
  //   { id: 2, description: 'Pendente' },
  //   { id: 3, description: 'Aguardando compras' },
  //   { id: 8, description: 'Devolvido Compras' },
  //   { id: 4, description: 'Análise do cliente' },
  //   { id: 5, description: 'Não aceita pelo cliente' },
  //   { id: 6, description: 'Cancelada' },
  //   { id: 7, description: 'Em aberto' },
  // ]

  ngOnInit() {
    this.getListStatus()
    this.createForm()
  }

  ngOnChanges() {
    // this.updateSearch()
  }

  getListStatus() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listStatus = response.data
        this.listStatus.unshift({ id: 0, descricao: 'Todos' })
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  // updateSearch() {
  //   this.formSearch.get('search')?.setValue(this.search ?? '')
  // }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      event: [''],
      client: [''],
      subClient: [''],
      consultantTg: [''],
      consultantClient: [''],
      consultantOperate: [''],
      dateStart: [''],
      dateEnd: [''],
    })
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = {
        codigoTg: this.formSearch.get('tgCode')!.value,
        nomeEvento: this.formSearch.get('event')!.value,

        cliente: this.formSearch.get('client')!.value,
        subCliente: this.formSearch.get('subClient')!.value,

        consultor: this.formSearch.get('consultantTg')!.value,
        consultorComercial: this.formSearch.get('consultantClient')!.value,
        consultorOperacional: this.formSearch.get('consultantOperate')!.value,

        dataInicio:
          this.formSearch.get('dateStart')!.value != ''
            ? moment(this.formSearch.get('dateStart')!.value).format(
                'DD/MM/YYYY',
              )
            : '',
        dataFinal:
          this.formSearch.get('dateEnd')!.value != ''
            ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
            : '',
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('tgCode')!.setValue('')
      this.formSearch.get('event')!.setValue('')
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('subClient')!.setValue('')
      this.formSearch.get('consultantTg')!.setValue('')
      this.formSearch.get('consultantClient')!.setValue('')
      this.formSearch.get('consultantOperate')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')

      this.responseSearch.emit({
        search: true,
        model: {
          codigoTg: '',
          cliente: '',
          subCliente: '',
          consultor: '',
          consultorComercial: '',
          nomeEvento: '',
          dataInicio: '',
          dataFinal: '',
          consultorOperacional: '',
        },
      })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('tgCode')!.value.trim().length > 0 ||
      this.formSearch.get('event')!.value.trim().length > 0 ||
      this.formSearch.get('client')!.value.trim().length > 0 ||
      this.formSearch.get('subClient')!.value.trim().length > 0 ||
      this.formSearch.get('consultantTg')!.value.trim().length > 0 ||
      this.formSearch.get('consultantClient')!.value.trim().length > 0 ||
      this.formSearch.get('consultantOperate')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value
      // this.formSearch.get('dateEmission')!.value ||
      // this.formSearch.get('status')!.value == 0 ||
      // this.formSearch.get('status')!.value != ''
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd' | 'dateEmission') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    } else if (type == 'dateEmission') {
      this.datepickerEmission()?.open()
    }
  }
}
